import { render, staticRenderFns } from "./BoxDemographicsGenderRate.vue?vue&type=template&id=9ccec502&"
import script from "./BoxDemographicsGenderRate.vue?vue&type=script&lang=ts&"
export * from "./BoxDemographicsGenderRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BoxDemographicsGenderRate.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxDemographicsGenderRate.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QCard,QIcon,QBtnToggle,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QBtnToggle,QCardSection})
